export default __webpack_public_path__ + "static/media/green-discord.c8df42ae.svg";